import { render } from "./SelectCustomerReturnReason.vue?vue&type=template&id=379f8766"
import script from "./SelectCustomerReturnReason.vue?vue&type=script&lang=js"
export * from "./SelectCustomerReturnReason.vue?vue&type=script&lang=js"

import "./SelectCustomerReturnReason.vue?vue&type=style&index=0&id=379f8766&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__